export const DASHBOARD_SITE_STATS = "/api/site/dashboard/inspection/analytics";
export const FTECH_SUB_SITE = "/api/site/subsites/list";
export const FETCH_SUB_SITE_WITH_GROUPID = "/api/site/dashboard/subsite/list";
export const FETCH_INSPECTION_TREND = "/api/site/dashboard/graph/inspection/trend";
export const FETCH_SITE_NEGATIVE_POSTIVE_STATS = "/api/site/dashboard/graph/response/stats";
export const FETCH_REGION_WISE_SCORE = "/api/site/dashboard/graph/region/score";
export const USER_WISE_INSPECTION_REPORT = "/api/site/users/inspection/data";
export const DELETE_SUBSITE = "/api/site/subsite/delete";
export const DELETE_MACHINE_RESPONSE = "/api/machine/questions/response/delete";
/** POST body: { responses: { uuid: string, priority: number }[] } — mirrors question priority update for quiz rows on a machine. */
export const UPDATE_QUIZ_RESPONSES_PRIORITY = "/api/machine/quiz/responses/update/responses-priority";
export const GET_MACHINE_DETAILS = "/api/machine/details";
export const GET_GROUPWISE_MACHINE_RESPONSE_STATS = "/api/dashboard/group/machine/response/stats";
export const GET_GROUPWISE_RESPONSE_TAG_STATS = "/api/dashboard/negative/tag/response/stats";
export const ADD_NEW_TAG = "/api/tags/create";
